import { Fragment, useState } from 'react';
import Modal, { ModalProps } from './Modal';

import Button from '../common/Button';
import { ModalResponse } from '../../enum/ModalResponse';
import { useTranslation } from 'react-i18next';

export interface ModalMeterBudgetWizardAdviceProps extends ModalProps {}
export default function ModalMeterBudgetWizardAdvice({
  isOpen,
  onClickAction,
  onClose,
}: ModalMeterBudgetWizardAdviceProps) {
  const { t } = useTranslation();
  const [modalResponse, setModalResponse] = useState<ModalResponse>();

  const handleClickCancel = () => {
    setModalResponse(ModalResponse.CANCEL);
    if (onClickAction) {
      onClickAction(ModalResponse.CANCEL);
    }
  };

  const handleClose = (modalResponse: ModalResponse | undefined) => {
    if (onClose) {
      onClose(modalResponse);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => handleClose(modalResponse)}
      actions={
        <Fragment>
          <Button className="btn btn--primary" onClick={handleClickCancel}>
            {t('common.close')}
          </Button>
        </Fragment>
      }
    >
      <Fragment>
        <p className="modal__message modal__message--break-line">
          {t('modal.meter.budget.wizard.advice')}
        </p>
      </Fragment>
    </Modal>
  );
}
